import { render, staticRenderFns } from "./Modal-shipping.vue?vue&type=template&id=3d4fef9e&scoped=true&lang=pug"
import script from "./Modal-shipping.vue?vue&type=script&lang=js"
export * from "./Modal-shipping.vue?vue&type=script&lang=js"
import style0 from "./Modal-shipping.vue?vue&type=style&index=0&id=3d4fef9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4fef9e",
  null
  
)

export default component.exports